import axios from "axios";
import React, { useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import DownloadLoadingModal from "./DownloadLoadingModal";
import VanishComponent from "./VanishComponent";
import { set } from "date-fns";

function LoanDetailsCardOd({ data, orderId }) {
  const token = localStorage.getItem("token");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [existError, setExistError] = useState(false);
  const [addedSuccess, setAddedSuccess] = useState(false);
  const LoanText = ({ text }) => {
    if (text === "Utilization Ratio") {
      return (
        <div className="flex flex-row justify-start items-center gap-1">
          <p className="text-xs text-[#8b8b8b] font-medium">{text}</p>
          {/* <MdInfoOutline
            size={"15"}
            color="#262626"
            className="cursor-pointer"
          /> */}
        </div>
      );
    } else {
      return <p className="text-xs text-[#8b8b8b] font-medium">{text}</p>;
    }
  };

  const LoanTableRow = ({
    leftLable,
    leftValue,
    rightLable,
    rightValue,
    styles,
    last,
  }) => {
    return (
      <div
        className={`mx-4 py-2 border-b border-[#f5f5f5] flex text-xs font-medium ${
          last && "border-b-0"
        }`}
      >
        <div className="w-[60%]">
          <LoanText text={leftLable} />
          {leftLable === "Utilization Ratio" ? (
            <p className={`mt-1 bg-[#FEE0FF] rounded p-1 w-fit`}>{`${
              leftValue + "%"
            }`}</p>
          ) : (
            <p
              className={`mt-1 ${
                styles ? "text-[#00394d] underline cursor-pointer" : ""
              }`}
            >
              {leftValue}
            </p>
          )}
        </div>
        <div className="w-[40%]">
          <LoanText text={rightLable} />
          <p className={`mt-1 `}>{rightValue}</p>
        </div>
      </div>
    );
  };

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  const handleStatementDownload = async (statementName) => {
    setDownloadLoading(true);
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/bajaj_finserv/service/${statementName}`,
        method: "POST",
        headers: { Authorization: token },

        data: {
          [statementName]: {
            order_uuid: orderId,
            report_type: "pdf1",
          },
        },
      };
      const res = await axios(options);
      if (res.data.status) {
        const url = res.data.data.result;
        handleDownloadFile(url);
        setAddedSuccess(true);
      } else {
        setExistError(res?.data?.error || "Error in downloading Statement");
      }
    } catch (error) {
      setExistError("Error in downloading Statement");
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleDownloadFile = (url, filename = "file.pdf") => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  return (
    <div className=" pt-3 ">
      <div className=" flex justify-between items-center">
        <p className=" text-sm font-semibold">Loan Details</p>
        <p
          className={` rounded-[13px] px-2 py-1 text-xs  ${
            data?.disbursed_status.status === "Disbursed" ||
            data?.disbursed_status.status === "Ready for disbursement"
              ? "bg-[#edfff4] text-[#0ba300]"
              : "bg-[#fff5f5] text-[#d30d00]"
          }`}
        >
          {data?.disbursed_status.status || "--"}
        </p>
      </div>
      <div className="text-xs flex justify-between mt-3 ">
        <LoanText text={`Pledging date : ${data?.pledged_date || "--"}`} />
        <LoanText
          text={`Disbursal date :  ${
            data?.disbursed_status.disbursal_date || "--"
          }`}
        />
      </div>
      <div className="mt-4 pb-1 flex flex-row w-full gap-4">
        <div className="flex justify-start flex-col w-[49.6%] gap-4">
          <div className="border rounded border-[#e6ebed] h-fit">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Pledge Details
            </div>
            <LoanTableRow
              leftLable={"Pledged Value (at time of lien mark)"}
              leftValue={
                formatToIndianRupees(data?.pledge_details?.pledged_value) ||
                "--"
              }
              rightLable={"Interest rate"}
              rightValue={
                data?.pledge_details?.roi
                  ? data?.pledge_details?.roi + " %"
                  : "--"
              }
            />
            <LoanTableRow
              leftLable={"Overdraft Limit"}
              leftValue={
                data?.od_limit !== null
                  ? formatToIndianRupees(data?.pledge_details?.od_limit)
                  : "--"
              }
              rightLable={"Pledge Type"}
              rightValue={
                data?.pledge_details?.pledge_type
                  ? data?.pledge_details?.pledge_type
                  : "--"
              }
              last={true}
            />
          </div>
          <div className="border rounded border-[#e6ebed] h-fit">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Loan Details
            </div>
            <LoanTableRow
              leftLable={"Utilization Ratio"}
              leftValue={
                data?.loan_details?.utilization_ratio != null
                  ? data?.loan_details?.utilization_ratio
                  : "--"
              }
              rightLable={"Principal Outstanding"}
              rightValue={
                data?.loan_details?.current_outstanding != null
                  ? formatToIndianRupees(
                      data?.loan_details?.current_outstanding
                    )
                  : "--"
              }
            />
            <LoanTableRow
              leftLable={"Current OD Limit"}
              leftValue={
                data?.loan_details?.drawing_power !== null
                  ? formatToIndianRupees(data?.loan_details?.drawing_power)
                  : "--"
              }
              rightLable={"Available Amount"}
              rightValue={
                data?.loan_details?.available_amount_for_disbursement !== null
                  ? formatToIndianRupees(
                      data?.loan_details?.available_amount_for_disbursement
                    )
                  : "--"
              }
            />

            <LoanTableRow
              leftLable={"Processing Fees"}
              leftValue={
                formatToIndianRupees(data?.loan_details?.processing_fees) ||
                "--"
              }
              rightLable={"Account Number"}
              rightValue={data?.loan_details?.account_number || "--"}
            />
            <LoanTableRow
              leftLable={"IFSC Code"}
              leftValue={data?.loan_details?.ifsc_code || "--"}
              rightLable={"LAN (Loan Application Number)"}
              rightValue={data?.loan_details?.lan || "--"}
            />
            <LoanTableRow
              leftLable={"Loan Number"}
              leftValue={data?.loan_details?.loan_number || "--"}
              rightLable={"Tenure"}
              rightValue={
                data?.loan_details?.tenture
                  ? data?.loan_details?.tenture + " M"
                  : "--"
              }
            />
          </div>
        </div>
        <div className="flex justify-start w-[49.6%] flex-col gap-4">
          <div className="border rounded border-[#e6ebed] h-fit">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Timestamp Details
            </div>

            <LoanTableRow
              leftLable={"KYC Completed"}
              leftValue={data?.timestamp_details?.kyc_completed_at || "--"}
              rightLable={"KFS (Key Fact Statement)"}
              rightValue={data?.timestamp_details?.kfs_completed_at || "--"}
            />
            <LoanTableRow
              leftLable={"E Signature"}
              leftValue={data?.timestamp_details?.esign_completed_at || "--"}
              rightLable={"E-Mandate"}
              rightValue={
                data?.timestamp_details?.emandate_completed_at || "--"
              }
            />
            <LoanTableRow
              leftLable={"Overdraft Facility Start"}
              leftValue={data?.timestamp_details?.od_facility_start || "--"}
              rightLable={"Overdraft Facility End"}
              rightValue={data?.timestamp_details?.od_facility_end || "--"}
            />
          </div>
          <div className="border rounded border-[#e6ebed] h-fit">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Statements
            </div>

            <div className="mx-4 py-2 border-b border-[#f5f5f5] flex text-xs font-medium">
              <div className="w-[60%]">
                <LoanText text={"Holding Statement"} />
                <button
                  onClick={() => handleStatementDownload("holding_statement")}
                  className={`mt-1 text-[#00394d] underline cursor-pointer`}
                >
                  Download
                </button>
              </div>
              <div className="w-[40%]">
                <LoanText text={"Transaction Statement"} />
                <button
                  onClick={() => handleStatementDownload("client_statement")}
                  className={`mt-1 text-[#00394d] underline cursor-pointer`}
                >
                  Download
                </button>
              </div>
            </div>
            <div className="mx-4 py-2 border-b border-[#f5f5f5] flex text-xs font-medium">
              <div className="w-[60%]">
                <LoanText text={"Foreclosure Statement"} />
                <button
                  onClick={() =>
                    handleStatementDownload("foreclosure_statement")
                  }
                  className={`mt-1 text-[#00394d] underline cursor-pointer`}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {downloadLoading && <DownloadLoadingModal />}
      <VanishComponent
        error={existError}
        success={addedSuccess}
        errorMessage={existError}
        successMessage={"Statement download Successful"}
        errorFunction={() => {
          setExistError(false);
        }}
        successFunction={() => {
          setAddedSuccess(false);
        }}
        timeOut={6000}
      />
    </div>
  );
}

export default LoanDetailsCardOd;
